/**
 =========================================================
 * Material Dashboard 2 React - v2.1.0
 =========================================================
 
 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)
 
 Coded by www.creative-tim.com
 
 =========================================================
 
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// Material Dashboard 2 React base styles
import breakpoints from 'assets/theme/base/breakpoints';

// Material Dashboard 2 React helper functions
import pxToRem from 'assets/theme/functions/pxToRem';

const {
  values: { sm, md, lg, xl, xxl }
} = breakpoints;

const SM = `@media (min-width: ${sm}px)`;
const MD = `@media (min-width: ${md}px)`;
const LG = `@media (min-width: ${lg}px)`;
const XL = `@media (min-width: ${xl}px)`;
const XXL = `@media (min-width: ${xxl}px)`;

const sharedClasses = (ownerState) => ({
  paddingRight: `${pxToRem(24)} !important`,
  paddingLeft: `${pxToRem(24)} !important`,
  marginRight: '0 !important',
  marginLeft: '0 !important',
  ...(ownerState &&
    !ownerState.disableGutters && {
      marginRight: 'auto !important',
      marginLeft: 'auto !important'
    }),
  maxWidth: '100% !important',
  width: '100% !important',
  position: 'relative'
});

const container = {
  styleOverrides: {
    root: ({ ownerState }) => ({
      [SM]: {
        ...sharedClasses(ownerState),
        ...(ownerState &&
          !ownerState.disableGutters && {
            maxWidth: '540px !important'
          })
      },
      [MD]: {
        ...sharedClasses(ownerState),
        ...(ownerState &&
          !ownerState.disableGutters && {
            maxWidth: '720px !important'
          })
      },
      [LG]: {
        ...sharedClasses(ownerState),
        ...(ownerState &&
          !ownerState.disableGutters && {
            maxWidth: '960px !important'
          })
      },
      [XL]: {
        ...sharedClasses(ownerState),
        ...(ownerState &&
          !ownerState.disableGutters && {
            maxWidth: '1140px !important'
          })
      },
      [XXL]: {
        ...sharedClasses(ownerState),
        ...(ownerState &&
          !ownerState.disableGutters && {
            maxWidth: '1320px !important'
          })
      }
    })
  }
};

export default container;
